import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import OtherOffers from '@pages/offer-page/other-offers/OtherOffers.vue';

export const otherOffers = () => {
  if (!document.getElementById('combinator-other-offers-app')) {
    return;
  }

  const app = createApp(OtherOffers);

  app.use(pinia);
  app.mount('#combinator-other-offers-app');
};
